import type { ReactNode } from 'react';

interface FieldProps {
  label: string;
  htmlFor: string;
  hint?: string;
  required?: boolean;
  size?: 'sm' | 'md';
  children: ReactNode;
}

/**
 * Labelled input wrapper for the asset form. Split out of AssetForm to
 * keep that file under the size cap; shared by every field on the form.
 */
export function Field({ label, htmlFor, hint, required, size = 'md', children }: FieldProps) {
  return (
    <label htmlFor={htmlFor} className="block">
      <div className="mb-1 flex items-center gap-1 text-xs font-medium text-fg-muted">
        {label}
        {required ? <span className="text-red-600">*</span> : null}
      </div>
      <div
        className={[
          'rounded-md border border-line-strong/20 bg-surface shadow-sm focus-within:border-slate-500 focus-within:ring-2 focus-within:ring-slate-900 focus-within:ring-offset-1 transition-colors',
          '[&>input]:block [&>input]:w-full [&>input]:bg-transparent [&>input]:px-3 [&>input]:text-sm [&>input]:outline-none',
          '[&>select]:block [&>select]:w-full [&>select]:bg-transparent [&>select]:px-3 [&>select]:text-sm [&>select]:outline-none',
          '[&>textarea]:block [&>textarea]:w-full [&>textarea]:bg-transparent [&>textarea]:px-3 [&>textarea]:py-2 [&>textarea]:text-sm [&>textarea]:outline-none',
          size === 'sm' ? '[&>input]:h-8 [&>select]:h-8' : '[&>input]:h-10 [&>select]:h-10',
        ].join(' ')}
      >
        {children}
      </div>
      {hint ? <p className="mt-1 text-[11px] text-fg-muted">{hint}</p> : null}
    </label>
  );
}
